<template>
  <NotificationTemplate
    :notification="notification"
    :projectName="notification.projectName"
    :showSubTitle="false"
    class="notification__item"
  >
    <template #pic>
      <div class="label-pic is-red">
        <icon
          data="@icon/alertSprint.svg"
          class="label-pic__icon"
          width="20px"
          height="19px"
        />
      </div>
    </template>
    <template #title>
      <BaseSubHeading
        size="large"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="500"
      >
        Jira synchronization disabled
      </BaseSubHeading>
    </template>
    <template #content>
      <BaseSubHeading
        size="medium"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="400"
        className="notification__jira-backlog-import-disabled"
      >
        Jira synchronization temporarily disabled due to errors. These issues may be related to
        outages or Jira configuration changes.
      </BaseSubHeading>
    </template>
  </NotificationTemplate>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Prop } from "vue-property-decorator"

import NotificationTemplate from "@/components/Notification/NotificationTemplate.vue"

import { Notification } from "@/models/Notification"

@Options({
  name: "JIRA_SYNCHRONIZATION_DISABLED",
  components: {
    NotificationTemplate
  }
})
export default class JIRA_SYNCHRONIZATION_DISABLED extends Vue {
  @Prop() readonly notification: Notification
}
</script>
